import React, { useContext } from 'react';
import DefaultLayout from '../../DefaultLayout/DefaultLayout';
import useHotels from './Hotels.hook';
import ContentBox from '../../common/ContentBox/ContentBox';
import HotelList from './HotelList/HotelList';
import HotelDetail from './HotelDetail/HotelDetail';
import { HotelsContext } from './Hotels.context';
import { AppContext } from '../../../App.context';
import FeatModal from 'Components/common/FeatModal/FeatModal';
import Onboarding from 'Components/Dashboard/Onboarding/Onboarding';
import { Upload } from 'antd';
import AppButton from 'Components/common/Forms/AppButton/AppButton';
export default function Hotels() {
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);

  const { hotelsState, hotelsActions } = useHotels();
  const popUpImage = require('../../../assets/images/conecta_pms.png');

  return (
    <DefaultLayout title={translate('layout.hotels')}>
      <HotelsContext.Provider value={{ hotelsState, hotelsActions }}>
        <ContentBox title={translate('hotels.addNewHotel')}>
          <HotelDetail />
          {appState.superUser && (
            <div
              style={{
                marginTop: '12px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                gap: '12px',
                alignItems: 'start',
              }}
            >
              <AppButton
                secondary
                text={translate('hotels.downloadTest')}
                action={() => hotelsActions.downloadTestFile()}
              />

              <Upload
                accept=".xlsx"
                listType="text"
                fileList={hotelsState.hotelFile ? [hotelsState.hotelFile] : []}
                maxCount={1}
                beforeUpload={hotelsActions.handleBeforeUpload}
                onRemove={hotelsActions.handleRemove}
                showUploadList={{
                  showRemoveIcon: true,
                }}
              >
                <AppButton secondary text={translate('hotels.uploadFile')} />
              </Upload>
            </div>
          )}
        </ContentBox>
        <ContentBox title={translate('hotels.title')} noPadding>
          <HotelList />
        </ContentBox>
        <FeatModal
          title={translate('pmsPopup.title')}
          subtitle={translate('pmsPopup.subtitle')}
          info1={translate('pmsPopup.legalTextNewHotel')}
          info2={translate('pmsPopup.text')}
          buttonText={translate('pmsPopup.button')}
          visible={hotelsState.showPmsPopup}
          onCancel={() => hotelsActions.setShowPmsPopup(false)}
          buttonAction={() => hotelsActions.goToPmsScreen()}
        />
        {/*
<Onboarding
          translate={translate}
          visible={hotelsState.showPmsPopup}
          onCancel={() => hotelsActions.setShowPmsPopup(false)}
          buttonAction={() => hotelsActions.goToPmsScreen()}
          popUpImage={popUpImage}
        />
       */}
      </HotelsContext.Provider>
    </DefaultLayout>
  );
}
